import React, { Component } from 'react';
import Aux from '../../hoc/Aux';
import * as messages from '../../messages';
import classes from '../../index.css';
import Input from '../../components/UI/Input/Input';
//import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import axios from '../../axios-ns';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';



class PaymentMethod extends Component {
    state = {
        //        paymentMethod: null,
        loading: false,
        transaction: null,
        //        transactionCode: null,
        controls: {
            paymentMethod: {
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: 'ONLINE_TRANSFER', displayValue: messages['ONLINE_TRANSFER'] },
                        { value: 'BANK_TRANSFER', displayValue: messages['BANK_TRANSFER'] },
                        { value: 'PAYPAL', displayValue: messages['PAYPAL'] }
                    ]
                },
                value: 'ONLINE_TRANSFER',
                validation: {
                    required: true
                }
            }
        }
    };

    componentDidMount() {
        axios.get('transaction/' + this.props.match.params.transactionCode + "/details")
            .then(response => {
                this.setState({ ...this.state, transaction: response.data });
            })
            .catch(err => {
                //TODO: handle error
            });
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                checked: event.target.checked,
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        this.setState({ ...this.state, loading: true });
        event.preventDefault();

        this.changePaymentMethod({
            paymentMethod: this.state.controls.paymentMethod.value,
            transactionCode: this.state.transaction.code
        });
    }

    changePaymentMethod(payload) {
        let url = 'transaction';

        this.setState({ ...this.state, loading: true })

        axios.put(url, payload)
            .then(response => {
                
                this.setState({
                    ...this.state,
                    transaction:  {...this.state.transaction, paymentMethod: response.data.paymentMethod},
                    loading: false
                });

                console.log("--->" + JSON.stringify(this.state));

            })
            .catch(err => {
                //TODO: show message that something went wrong
                console.log("--->Err");
                this.setState({ ... this.state, loading: false });
            })
    }

    render() {
        let methodInfo = null;

        if (this.state.transaction) {
            switch (this.state.transaction.paymentMethod) {
                case 'ONLINE_TRANSFER':
                    methodInfo = (
                        <form method="post" action="https://ssl.dotpay.pl/">
                            <input type="hidden" value="51415" name="id" />
                            <input type="hidden" value={this.state.transaction.price} name="amount" />
                            <input type="hidden" value={this.state.transaction.productName + " Identyfikator transakcji: " + this.state.transaction.code} name="description" />
                            <input type="hidden" value={this.state.transaction.email} name="email" />
                            <input type="hidden" value="PLN" name="currency" />
                            <input type="hidden" value="pl" name="lang" />
                            <input type="hidden" value="3" name="typ" />
                            <input type="hidden" value="POL" name="country" />
                            <input type="hidden" value="https://nauka-spiewu.pl/vocaldemy/front/transaction-completed" name="URL" />
                            <input type="hidden" value={"http://nauka-spiewu.pl/vocaldemy/back/public/transaction/" + this.state.transaction.code + "/success"} name="URLC" />
                            <input type="submit" style={{color: '#252e4a', backgroundColor: '#fff', fontSize: '20px', padding: '10px', borderRadius: '5px', border: '1px solid #252e4a'}} value="Dokonaj płatności online" alt="Zapłać z Dotpay - szybko, łatwo i bezpiecznie!" name="submit" />
                        </form>);
                    break;
                case 'BANK_TRANSFER':
                    methodInfo = <p style={{textAlign: 'left', fontSize: '14px', border: '1px solid #ccc', padding: '5px', margin: '5px'}}>Proszę dokonać przelew:<br/>
                        Kwota:<br/>
                        <b>{this.state.transaction.price}</b><br/>
                        Tytułem:<br/>
                        <b>{this.state.transaction.productCode + " Identyfikator transakcji: " + this.state.transaction.code}</b><br/>
                        Konto:<br/>
                        <b>22 1140 2004 0000 3402 7098 0620</b><br/>
                        Odbiorca:<br/>
                        <b>Whizzarts Marcin Majewski</b>
                    </p>
                    break;
                case 'PAYPAL':
                    let path = "https://ssl.dotpay.pl/?id=%2051415&kwota=" + this.state.transaction.price + "&opis=" + this.state.transaction.productCode + "_" + this.state.transaction.code + "&channel=212&blokuj=1";
                    methodInfo = <a href={path}>Dokonaj płatności z PayPal</a>
                    break;
            }
        }

        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    error={formElement.config.error}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let changePaymentForm = null;

        if (this.state.loading) {
            changePaymentForm = <Spinner />;
        } else {
            changePaymentForm = (<form onSubmit={this.submitHandler}>
                <br/><p>{messages.YOU_CAN_CHANGE_PAYMENT_FORM}</p>
            {form}
                <Button color='primary' type="submit">
                    {messages.CHANGE_PAYMENT_FORM}
            </Button>
            </form>
            )
        }

        let view = <Spinner />;

        if (this.state.transaction) {
            view = (
                <Card className={classes.Form}>
                    <CardHeader title={messages.COURSE_PAYFORM} className={classes.Head} />
                <div className={classes.PaymentMethod}><h2>Wybrano {messages[this.state.transaction.paymentMethod]}</h2>
                    {methodInfo}
                    {changePaymentForm}
                </div>
                </Card>
                );
        }

        return <Aux>{view}</Aux>;
    };
}

export default PaymentMethod;